import Alert from './alert';
import API from './api';
import Auth from './auth';
import Dashboard from './dashboard';
import DataTables from './dataTables';
import Documents from './documents';
import FormResponses from './formResponses';
import Forms from './forms';
import Layout from './layout';
import Notices from './notices';
import OnlineUsers from './onlineUsers';
import PageHeader from './pageHeader';
import Preferences from './preferences';
import Pusher from './pusher';
import Reports from './reports';
import StaffReportsAdverseEvents from './staff/reports/adverseEvents';
import StaffReportsEmployees from './staff/reports/employees';
import StaffReportsEnquiries from './staff/reports/enquiries';
import StaffReportsServiceUsers from './staff/reports/serviceUsers';
import StatusService from './status';

export const load = (app) => {
	app.service('AlertService', Alert);
	app.service('APIService', API);
	app.service('AuthService', Auth);
	app.service('DashboardService', Dashboard);
	app.service('DataTablesService', DataTables);
	app.service('DocumentsService', Documents);
	app.service('FormResponseService', FormResponses);
	app.service('FormService', Forms);
	app.service('LayoutService', Layout);
	app.service('NoticesService', Notices);
	app.service('OnlineUsersService', OnlineUsers);
	app.service('PageHeaderService', PageHeader);
	app.service('PreferencesService', Preferences);
	app.service('PusherService', Pusher);
	app.service('ReportsService', Reports);
	app.service('StaffReportsAdverseEventsService', StaffReportsAdverseEvents);
	app.service('StaffReportsEmployeesService', StaffReportsEmployees);
	app.service('StaffReportsEnquiriesService', StaffReportsEnquiries);
	app.service('StaffReportsServiceUsersService', StaffReportsServiceUsers);
	app.service('StatusService', StatusService);
};


// WEBPACK FOOTER //
// ./src/js/services/loader.js